module.exports = __webpack_public_path__ + "static/media/backward.a93421ce.svg";